import { Grid, makeStyles, useMediaQuery } from '@material-ui/core';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { toggleIsInfoPaneExpanded } from '../../redux_store';
import { INFO_PANE_ROUTES, INFO_PANE_SIZES } from './constants';
import NavPinButton from '../Shared/NavPinButton';
import theme from '../../config/theme';

const useStyles = makeStyles((theme) => ({
  infoPane: {
    flexShrink: 0,
    width: INFO_PANE_SIZES.small_width,
    transition: 'width 0.3s ease, marginTop 0.3s ease, borderTopLeftRadius 0.3s ease, backgroundColor 0.3s ease, box-shadow 0.3s ease',
    flexWrap: 'nowrap',
    position: 'relative',
    marginTop: 80,
    borderTopLeftRadius: 8,
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    zIndex: 100,
    height: '100%',
    maxHeight: 'calc(100vh - 80px)',
    overflowX: 'hidden',
    boxShadow: '-4px 0 12px rgba(0, 0, 0, 0.1)',
  },
  pinnedInfoPane: {
    width: INFO_PANE_SIZES.full_width,
    flexWrap: 'nowrap',
    height: '100%',
    maxHeight: 'calc(100vh - 80px)',
    transition: 'width 0.3s ease, marginTop 0.3s ease, borderTopLeftRadius 0.3s ease, backgroundColor 0.3s ease, box-shadow 0.3s ease',
    backgroundColor: '#ffffff',
    boxShadow: '-8px 0 24px rgba(0, 0, 0, 0.15)',
  },
  hideInfoPane: {
    width: 0,
    maxWidth: 0,
  },
  icon: {
    fill: '#5B65DC',
  },
  closeButtonWrapper: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
  },
  cursor: {
    cursor: 'pointer',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  willHeight: {
    height: '100vh',
    marginTop: 0,
    // transition: '0.3s',
    backgroundColor: '#ffffff',
    borderTopLeftRadius: 0,
    maxHeight: '100vh',
  },
  smallScreen: {
    position: 'absolute',
    right: 0,
  }
}));

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  width: INFO_PANE_SIZES.full_width,
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 50,
  paddingTop: 20,
  height: 'calc(100% - 30px)',
  transition: '0.3s',
};

const InfoPane = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { isInfoPaneExpanded, currentPage } = useSelector((state) => state.infoPane);
  const { settings } = useSelector((state) => state.table);
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Grid
      container
      direction='column'
      id={'infoPane'}
      className={cx(classes.infoPane, {
        [classes.pinnedInfoPane]: isInfoPaneExpanded,
        [classes.cursor]: !isInfoPaneExpanded,
        [classes.hideInfoPane]: !currentPage?.uuid,
        [classes.willHeight]: settings?.isFullScreen,
        [classes.smallScreen]: !isDesktop,
      })}
      onClick={!isInfoPaneExpanded ? (event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(toggleIsInfoPaneExpanded(true));
      } : null}
    >
      <div
        style={{
          ...containerStyle,
          padding: isInfoPaneExpanded ? 0 : 12,
        }}
      >
        {INFO_PANE_ROUTES[currentPage?.currentPageName]}
      </div>

      <div className={classes.closeButtonWrapper}>
        <NavPinButton
          customContainerStyle={{
            padding: isInfoPaneExpanded ? 15 : '15px 3px',
            transition: '0.3s',
          }}
          isSideMenuPinned={!isInfoPaneExpanded}
          changeIsSideMenuPinned={() => dispatch(toggleIsInfoPaneExpanded(!isInfoPaneExpanded))}
          blueStyle
          iconClassname={classes.icon}
        />
      </div>
    </Grid>
  );
};

export default InfoPane;
